import React, { useState } from 'react';
import './LoginPopup.css';
import { assets } from '../../assets/assets';

function LoginPopup(props) {
  const {setShowLogin} = props;
  const [currentState, setCurrentState] = useState("Sign Up");
  return (
    <div className='login-popup'>
      <form action="" className="login-popup-container">
        <div className="login-popup-title">
          <h2>{currentState}</h2>
          <img onClick={() => setShowLogin(false)} src={assets.cross_icon} alt=""  />
        </div>
        <div className="login-popup-inputs">
          {currentState === "Sign Up" && (
          <input type="text" placeholder='Your name' required/>
          )}
          <input type="email" placeholder='Your email' required/>
          <input type="password" placeholder='password' required/>
        </div>
        
          <button>{currentState === "Sign Up" ? "Create account" :"Login"}</button>
        <div className="login-popup-condition">
          <input type="checkbox" name="" id=""  required/>
          <p>By continuing, i agree to the terms of use & privacy policy</p>
        </div>
        {currentState === "Sign Up" ? (
          <p>Allrady have an account? <span onClick={()  => setCurrentState("Login") }>Click here</span></p>
        ) : (
        <p>Create a new account? <span onClick={() => setCurrentState("Sign Up")}>Click here</span></p>
        )}

      </form>
      </div>
  )
}

export default LoginPopup